<template>
  <div>
    <h4 v-if="this.headerDefinition._id">Header-Definition bearbeiten</h4>
    <h4 v-if="!this.headerDefinition._id">Header-Definition erstellen</h4>
    <div
      role="alert"
      class="c-alert c-alert--success"
      style="margin: 2rem 0;"
      v-if="showSuccess"
    >
      Header-Definition gespeichert
    </div>

    <div
      role="alert"
      class="c-alert c-alert--warning"
      style="margin: 2rem 0;"
      v-if="showError"
    >
      Fehler beim Speichern der Header-Definition
    </div>

    <bos-input
      label="Anzeigename (de):"
      :required="true"
      v-model="headerDefinition.displayNameDe"
      :error="errors.displayNameDe"
    />
    <bos-input
      label="Anzeigename (fr):"
      :required="true"
      v-model="headerDefinition.displayNameFr"
      :error="errors.displayNameFr"
    />
    <bos-input
      label="Anzeigename (en):"
      :required="true"
      v-model="headerDefinition.displayNameEn"
      :error="errors.displayNameEn"
    />
    <bos-input
      label="Leistungsgruppe:"
      :required="true"
      v-model="headerDefinition.serviceGroupId"
      :error="errors.serviceGroupId"
    />
    <bos-input
      label="Infotext (de)"
      :required="true"
      v-model="headerDefinition.infoTexts.textDe"
      type="wysiwyg"
      :error="errors.infoTextDe"
    />
    <bos-input
      label="Infotext (fr)"
      :required="true"
      v-model="headerDefinition.infoTexts.textFr"
      type="wysiwyg"
      :error="errors.infoTextFr"
    />
    <bos-input
      label="Infotext (en)"
      :required="true"
      v-model="headerDefinition.infoTexts.textEn"
      type="wysiwyg"
      :error="errors.infoTextEn"
    />
    <bos-button
      v-if="!this.headerDefinition._id"
      @click="createHeaderDefinition"
      small
    >
      Erstellen
    </bos-button>
    <bos-button
      small
      v-if="this.headerDefinition._id"
      @click="updateHeaderDefinition"
    >
      Aktualisieren
    </bos-button>
  </div>
</template>

<script>
import BosButton from '@/components/BosButton'
import BosInput from '@/components/BosInput'
import ApiService from '@/services/ApiService'
import easyScroll from 'easy-scroll'
import FormValidator from '@/services/FormValidator'

export default {
  name: 'AdminCoreDataHeaderDefinitionForm',
  components: { BosInput, BosButton },
  data() {
    return {
      showError: false,
      showSuccess: false,
      headerDefinition: {
        infoTexts: {}
      },
      errors: {
        displayNameDe: {
          hasError: false
        },
        displayNameFr: {
          hasError: false
        },
        displayNameEn: {
          hasError: false
        },
        infoTextDe: {
          hasError: false
        },
        infoTextFr: {
          hasError: false
        },
        infoTextEn: {
          hasError: false
        },
        serviceGroupId: {
          hasError: false
        }
      }
    }
  },
  methods: {
    scrollUp() {
      easyScroll({
        scrollableDomEle: window,
        direction: 'top',
        duration: 1250,
        easingPreset: 'easeInOutQuad',
        scrollAmount: window.scrollY
      })
    },
    getValidationRules() {
      return [
        {
          value: this.headerDefinition.displayNameDe,
          required: true,
          errorKey: 'displayNameDe'
        },
        {
          value: this.headerDefinition.displayNameFr,
          required: true,
          errorKey: 'displayNameFr'
        },
        {
          value: this.headerDefinition.displayNameEn,
          required: true,
          errorKey: 'displayNameEn'
        },
        {
          value: this.headerDefinition.infoTexts.textDe,
          required: true,
          errorKey: 'infoTextDe'
        },
        {
          value: this.headerDefinition.infoTexts.textFr,
          required: true,
          errorKey: 'infoTextFr'
        },
        {
          value: this.headerDefinition.infoTexts.textEn,
          required: true,
          errorKey: 'infoTextEn'
        },
        {
          value: this.headerDefinition.serviceGroupId,
          required: true,
          errorKey: 'serviceGroupId'
        }
      ]
    },
    createHeaderDefinition() {
      FormValidator.validateForm(this.getValidationRules(), this.errors).then(
        () => {
          this.showError = false
          this.headerDefinition.order = 99

          ApiService.createHeaderDefinition(this.headerDefinition).then(
            result => {
              if (result.status === 200 || result.status === 201) {
                this.$router.push({
                  name: 'AdminCoreDataHeaderDefinitionOverview'
                })
                this.scrollUp()
              }
            },
            () => {
              this.showError = true
              this.scrollUp()
            }
          )
        }
      )
    },
    updateHeaderDefinition() {
      FormValidator.validateForm(this.getValidationRules(), this.errors).then(
        () => {
          this.showError = false
          ApiService.updateHeaderDefinition(this.headerDefinition).then(
            result => {
              if (result.status === 200) {
                this.$router.push({
                  name: 'AdminCoreDataHeaderDefinitionOverview'
                })
                this.scrollUp()
              }
            },
            error => {
              console.warn(error)
              this.showError = true
              this.scrollUp()
            }
          )
        }
      )
    },
    toggleSuccess() {
      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 2750)
    }
  },
  mounted() {
    // Load task by id.
    if (this.$route.params.id) {
      ApiService.getHeaderDefinition(this.$route.params.id).then(res => {
        this.headerDefinition = res.data
      })
    }
  }
}
</script>

<style scoped></style>
